import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Tab, Nav } from 'react-bootstrap';
import _, { find as _find, findIndex as _findIndex, forEach as _forEach } from 'lodash';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import withRouter from 'js/withRouter';
import { Tooltip } from 'react-tooltip';
import { S3_LINKS } from 'js/constants';
import { setVariables } from 'actions/EditorActions';
import CollapseIt from 'cc-editor/helpers/CollapseIt';
import CustomScrollbar from 'js/wrapper/CustomScrollbar';
import { getDeviceType } from './actions/deviceType';
import { findSpace, getRasterSlots, isSpaceFreeAt, lookForTemplateBlock } from './actions/Raster';
// --- HELPER FUNCTIONS ---
const getSortedBlocks = (cRowInit, blocks) => {
    let cRow = cRowInit; // cRow is the remaining space in the current column (row)
    let col = 1; // col tracks the current column
    const sortedBlock = [];
    for (let i = 0; i < blocks.length; i++) {
        const spaceNeeded = blocks[i].page_space_needed || 0;
        // 1. Check if the block fits in the current column (space cRow)
        if (spaceNeeded <= cRow) {
            // Set the remainder (R) of all previously inserted blocks in this column to 0.
            for (let a = 0; a < sortedBlock.length; a++) {
                // Checks if the existing block (sortedBlock[a]) is located in the current column (col).
                if (sortedBlock[a].col === col) {
                    sortedBlock[a].R = 0;
                }
            }
            cRow = cRow - spaceNeeded; // Subtract 3rd place from the remaining places
        }
        else {
            // 4. Doesn't fit: Column break
            col = col + 1;
            cRow = cRowInit;
            cRow = cRow - spaceNeeded; // Subtract the space from the new initial space
        }
        // 5. Push block into the results array (with the current remaining place cRow)
        sortedBlock.push({ id: blocks[i].id, col: col, R: cRow });
    }
    return sortedBlock;
};
const getMaxFreeRowInSpace = (_sortedBlocks) => {
    let freeSpace = 0;
    for (let b = 0; b < _sortedBlocks.length; b++) {
        if (_sortedBlocks[b].R > freeSpace) {
            freeSpace = _sortedBlocks[b].R;
        }
    }
    return freeSpace;
};
const TemplateBlockCategoryFTs = (props) => {
    const { templateBlocks, pageSpace, currentPage, usedBlocks, raster, templateSettings, pageAmount, appIntl, blockContainer, init, endless, insertContentBlock, setVariables, allUsedBlocks, allUsedBlocksContent, } = props;
    let deviceType = getDeviceType();
    /*
      useEffect(() => {
        const stageElement = document.getElementById('stage');
        if (stageElement) {
          updatePageSize(stageElement.offsetWidth, stageElement.offsetHeight);
        }
      }, [updatePageSize]);
    */
    useEffect(() => {
        // Tooltip.rebuild();
    });
    const insertBlock = useCallback((e) => {
        e.preventDefault();
        const blockId = e.currentTarget.getAttribute('data-block');
        const blockIndex = e.currentTarget.getAttribute('data-index');
        if (blockId && blockIndex) {
            setVariables('unsavedtrue');
            insertContentBlock(blockId, blockIndex);
        }
    }, [setVariables, insertContentBlock]);
    // main logic to calculate free space
    const freeSlotsAndContainerClass = () => {
        let freeSlots = [];
        let containerClass = '';
        if (blockContainer) {
            const containerBlock = _find(usedBlocks, { id: blockContainer });
            if (containerBlock) {
                // logic for block container
                for (let k = 0; k < containerBlock.container_cols; k++) {
                    if (containerBlock.container_space * containerBlock.container_cols > containerBlock.space_consumed) {
                        if (containerBlock.space_consumed <= containerBlock.container_space && k === 0) {
                            freeSlots.push(containerBlock.container_space - containerBlock.space_consumed);
                        }
                        else if (k > 0 && containerBlock.space_consumed > containerBlock.container_space * k) {
                            let freeSpace = 0;
                            for (let spaceConsumed = containerBlock.space_consumed; spaceConsumed > 0; spaceConsumed -= containerBlock.container_space) {
                                freeSpace = containerBlock.container_space - spaceConsumed;
                            }
                            freeSlots.push(freeSpace > 0 ? freeSpace : 0);
                        }
                        else if (k > 0) {
                            // nothing
                        }
                    }
                }
                let freeSpace = 0;
                const _sortedBlocks = getSortedBlocks(containerBlock.container_space, containerBlock.blocks);
                if (_sortedBlocks.length > 0) {
                    let startSort = false;
                    _forEach(_sortedBlocks, (sBlock) => {
                        if (sBlock.col === containerBlock.container_cols) {
                            startSort = true;
                        }
                    });
                    if (startSort) {
                        freeSpace = getMaxFreeRowInSpace(_sortedBlocks);
                        freeSlots = [freeSpace];
                    }
                    else {
                        freeSlots.push(containerBlock.container_space);
                    }
                }
                else {
                    freeSlots.push(containerBlock.container_space);
                }
                if (containerBlock.container_class) {
                    containerClass = containerBlock.container_class;
                }
            }
            else {
                console.log('Error: container block not found');
            }
        }
        else {
            // logic for main raster
            freeSlots = getRasterSlots(raster, currentPage, pageSpace, 0, 0, endless);
        }
        return { freeSlots, containerClass };
    };
    const { freeSlots, containerClass } = freeSlotsAndContainerClass();
    const blockCategory = [];
    const blockCategoryPanes = [];
    let firstElement = '';
    _forEach(templateBlocks, (category, i) => {
        const blockCategoryVariants = [];
        let eventKey = 'block-category-' + i;
        const categoryName = getNameInCurrentLanguage(category.category, appIntl);
        const isVisible = (!init && categoryName === 'Initial') || categoryName !== 'Initial';
        if (isVisible) {
            if (firstElement === '') {
                firstElement = eventKey;
            }
        }
        if (isVisible) {
            // Nav-Item für die waagerechte Leiste oben
            blockCategory.push(_jsx(Nav.Item, { children: _jsx(Nav.Link, { eventKey: eventKey, "data-tooltip-content": categoryName, "data-tooltip-id": "top", children: _jsx("i", { className: category.thumb }) }) }, eventKey));
            // variants
            _forEach(category.variants, (variant, j) => {
                const blockCategoryVariantsBlocks = [];
                _forEach(variant.blocks, (block, k) => {
                    const blockIndex = i + '.' + j + '.' + k;
                    let excludePages = [];
                    if (block.exclude_pages !== null && block.exclude_pages !== '' && block.exclude_pages !== false) {
                        const excludeStr = String(block.exclude_pages);
                        excludePages = excludeStr.includes('.')
                            ? excludeStr.split('.')
                            : excludeStr.split(',');
                    }
                    const styles = {
                        background: `url(${S3_LINKS.TEMPLATES}${templateSettings.id}/images/${block.thumb}) no-repeat center center`,
                    };
                    let blockUsed = false;
                    let variantBlockUsed = false;
                    let documentBlockUsed = false;
                    let categoryBlockUsed = false;
                    let oversizeUnavailable = false;
                    let spaceBlocked = false;
                    let noRasterSpace = true;
                    let rasterOverflow = false;
                    let parentNotAvailable = false;
                    let disableGroup = false;
                    // 1. blockUsed - once per page
                    if (_findIndex(usedBlocks, ['template_id', block.id]) !== -1) {
                        blockUsed = true;
                    }
                    else if (blockUsed === false) {
                        _.forEach(usedBlocks, (_block) => {
                            if (_.findIndex(_block.blocks, ['template_id', block.id]) >= 0) {
                                blockUsed = true;
                            }
                        });
                    }
                    // 2. documentBlockUsed - once per document
                    if (block.once_per_document && lookForTemplateBlock(raster, block.id)) {
                        documentBlockUsed = true;
                    }
                    else if (block.once_per_document && _.findIndex(allUsedBlocks, ['id', block.id]) >= 0) {
                        documentBlockUsed = true;
                    }
                    // 3. spaceBlocked - (Is the space already occupied?)
                    if (block.top >= 0 && raster[currentPage] && raster[currentPage][block.top] !== '') {
                        spaceBlocked = true;
                    }
                    // 4. noRasterSpace - (Is there enough space?)
                    _forEach(freeSlots, slot => {
                        if (slot >= block.page_space_needed) {
                            noRasterSpace = false;
                        }
                    });
                    if (block.page_space_needed === 0) {
                        noRasterSpace = false;
                    }
                    // 5. variantBlockUsed - once per variant
                    if (typeof block.once_per_variant !== 'undefined' &&
                        block.once_per_variant !== '' &&
                        _findIndex(usedBlocks, ['once_per_variant', block.once_per_variant]) !== -1) {
                        variantBlockUsed = true;
                    }
                    else if (typeof block.once_per_variant !== 'undefined' &&
                        block.once_per_variant !== '' &&
                        _findIndex(usedBlocks, ['once_per_variant', block.once_per_variant]) === -1) {
                        _.forEach(usedBlocks, (_block) => {
                            if (_.findIndex(_block.blocks, ['once_per_variant', block.once_per_variant]) >= 0) {
                                variantBlockUsed = true;
                            }
                        });
                    }
                    // 6. categoryBlockUsed - once per category
                    if (typeof block.once_per_category !== 'undefined' &&
                        block.once_per_category !== '' &&
                        _findIndex(usedBlocks, ['once_per_category', block.once_per_category]) !== -1) {
                        categoryBlockUsed = true;
                    }
                    else if (typeof block.once_per_category !== 'undefined' &&
                        block.once_per_category !== '' &&
                        _findIndex(usedBlocks, ['once_per_category', block.once_per_category]) === -1) {
                        _.forEach(usedBlocks, (_block) => {
                            if (_.findIndex(_block.blocks, ['once_per_category', block.once_per_category]) >= 0) {
                                categoryBlockUsed = true;
                            }
                        });
                    }
                    // 7. rasterOverflow - (Does the block overlap other blocks?)
                    if (block.top >= 0) {
                        _forEach(usedBlocks, (usedBlock) => {
                            if (usedBlock.top > block.top &&
                                block.top + block.page_space_needed > usedBlock.top) {
                                rasterOverflow = true;
                            }
                        });
                    }
                    // 8. oversizeUnavailable - (Plus size available?)
                    if (typeof block.oversize !== 'undefined' &&
                        block.oversize !== 0 &&
                        block.oversize !== null &&
                        !noRasterSpace) {
                        // Logic for page restrictions
                        if ((block.oversize_direction === 'Right' && currentPage + 1 === pageAmount && templateSettings.format.order_pages !== 'down') ||
                            (block.oversize_direction === 'Left' && currentPage + 1 === pageAmount / 2 && templateSettings.format.divide_pages === 'half' && templateSettings.format.order_pages === 'down-up') ||
                            (block.oversize_direction === 'Right' && currentPage + 1 === pageAmount / 2 && templateSettings.format.divide_pages === 'half' && templateSettings.format.order_pages !== 'down-up') ||
                            (block.oversize_direction === 'Left' && currentPage === pageAmount / 2 && templateSettings.format.divide_pages === 'half') ||
                            (block.oversize_direction === 'Right' && currentPage === 0 && templateSettings.format.order_pages === 'down-up') ||
                            (block.oversize_direction === 'Left' && currentPage === 0 && templateSettings.format.order_pages !== 'down-up' && templateSettings.format.order_pages !== 'down')) {
                            oversizeUnavailable = true;
                        }
                        if (!oversizeUnavailable) {
                            const offsetTop = findSpace(raster, currentPage, block.page_space_needed, 0, pageSpace);
                            let checkLinkedTo = false;
                            const isRight = ((block.oversize_direction === 'Right' && templateSettings.format.order_pages !== 'down-up') ||
                                (block.oversize_direction === 'Right' && templateSettings.format.order_pages === 'down-up' && currentPage >= pageAmount / 2) ||
                                (block.oversize_direction === 'Left' && templateSettings.format.order_pages === 'down-up' && currentPage < pageAmount / 2));
                            if (isRight) {
                                checkLinkedTo = isSpaceFreeAt(raster, currentPage + 1, offsetTop, block.page_space_needed);
                            }
                            else { // Left - else if replaced by else only
                                checkLinkedTo = isSpaceFreeAt(raster, currentPage - 1, offsetTop, block.page_space_needed);
                            }
                            oversizeUnavailable = !checkLinkedTo;
                        }
                    }
                    // 9. parentNotAvailable - (Block is child element without matching parent)
                    if (block.block_combination_child !== null && block.block_combination_child !== '') {
                        parentNotAvailable = true;
                        const blockCombinationChild = block.block_combination_child.split(',');
                        _forEach(blockCombinationChild, (blockCC) => {
                            if (_findIndex(usedBlocks, ['block_combination_parent', blockCC]) !== -1) {
                                parentNotAvailable = false;
                            }
                        });
                        if (parentNotAvailable === true) {
                            _.forEach(usedBlocks, (_block) => {
                                _forEach(blockCombinationChild, (blockCC) => {
                                    if (_findIndex(_block.blocks, ['block_combination_parent', blockCC]) !== -1) {
                                        parentNotAvailable = false;
                                    }
                                });
                            });
                        }
                    }
                    // 10. disableGroup - (Disabled by another block in the document/on page)
                    if (block.disable_group !== null && block.disable_group !== '' && block.disable_group !== undefined) {
                        let usedBlockVariant = usedBlocks;
                        const splitBlockOptions = block.disable_group.split('#');
                        const splitBlockVariants = splitBlockOptions[0].split(',');
                        const splitDisableGroups = splitBlockOptions[1].split(',');
                        _forEach(splitDisableGroups, (blockDG, i) => {
                            if (splitBlockVariants[i] === 'D') {
                                usedBlockVariant = allUsedBlocksContent;
                            }
                            const even = i % 2 === 0;
                            if (even) {
                                // Check at even level (perPage or perDocument)
                                _forEach(usedBlockVariant, (_usedBlock) => {
                                    let splitUsedBlockDisableGroups = [];
                                    if (_usedBlock.disable_group !== '' && _usedBlock.disable_group !== undefined) {
                                        splitUsedBlockDisableGroups = _usedBlock.disable_group.split('#');
                                        const splitUsedDisableGroups = splitUsedBlockDisableGroups[1].split(',');
                                        if ((splitUsedDisableGroups === null || splitUsedDisableGroups === void 0 ? void 0 : splitUsedDisableGroups.length) > 0 &&
                                            splitUsedDisableGroups[i + 1] === splitDisableGroups[i] &&
                                            splitUsedDisableGroups[i + 1] !== 'x' &&
                                            splitDisableGroups[i] !== 'x') {
                                            disableGroup = true;
                                        }
                                    }
                                });
                                // check in containers
                                if (disableGroup === false) {
                                    _forEach(usedBlockVariant, (_usedBlock) => {
                                        var _a;
                                        if (((_a = _usedBlock === null || _usedBlock === void 0 ? void 0 : _usedBlock.blocks) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                            _.forEach(_usedBlock === null || _usedBlock === void 0 ? void 0 : _usedBlock.blocks, (blockInsideContainer) => {
                                                let splitUsedBlockDisableGroupsIC = [];
                                                if (blockInsideContainer.disable_group !== '' &&
                                                    blockInsideContainer.disable_group !== undefined) {
                                                    splitUsedBlockDisableGroupsIC = blockInsideContainer.disable_group.split('#');
                                                    const splitUsedDisableGroupsIC = splitUsedBlockDisableGroupsIC[1].split(',');
                                                    if ((splitUsedDisableGroupsIC === null || splitUsedDisableGroupsIC === void 0 ? void 0 : splitUsedDisableGroupsIC.length) > 0 &&
                                                        splitUsedDisableGroupsIC[i + 1] === splitDisableGroups[i] &&
                                                        splitUsedDisableGroupsIC[i + 1] !== 'x' &&
                                                        splitDisableGroups[i] !== 'x') {
                                                        disableGroup = true;
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                    // // Last availability check
                    const isUnavailable = ((block.once_per_page && blockUsed) ||
                        rasterOverflow || categoryBlockUsed || variantBlockUsed || documentBlockUsed ||
                        noRasterSpace || spaceBlocked ||
                        (blockContainer && !block.inner) ||
                        (blockContainer && block.container_class !== containerClass) ||
                        (!blockContainer && block.only_inside_block) ||
                        (!blockContainer && block.inline_block) ||
                        oversizeUnavailable || parentNotAvailable || disableGroup ||
                        (typeof block.restricted_to_page !== 'undefined' && block.restricted_to_page >= 0 &&
                            parseInt(currentPage.toString()) + 1 !== parseInt(block.restricted_to_page.toString())) ||
                        (excludePages.length > 0 && excludePages.includes((currentPage + 1).toString())) ||
                        (templateSettings.last_page_number === 'last' && parseInt(currentPage.toString()) + 1 === pageAmount && excludePages.includes('last')) ||
                        (block.only_last && parseInt(currentPage.toString()) + 1 !== pageAmount));
                    if (isUnavailable) {
                        blockCategoryVariantsBlocks.push(_jsx("div", { className: "thumb disabled", "data-tooltip-content": getNameInCurrentLanguage(block.title, appIntl), "data-tooltip-id": "top", children: _jsx("a", { href: "#", "data-block": block.id, "data-index": blockIndex, "data-space": block.page_space_needed, style: styles }) }, 'blockCategoryVariantsBlocksDisabled' + block.id + '_' + i));
                    }
                    else {
                        blockCategoryVariantsBlocks.push(_jsx("div", { className: "thumb", "data-tooltip-content": getNameInCurrentLanguage(block.title, appIntl), "data-tooltip-id": "top", children: _jsx("a", { href: "#", "data-block": block.id, "data-index": blockIndex, "data-space": block.page_space_needed, style: styles, onClick: insertBlock }) }, 'blockCategoryVariantsBlocks' + block.id + '_' + i));
                    }
                });
                const panelId = eventKey + '-' + j;
                const variantTitle = getNameInCurrentLanguage(variant.title, appIntl);
                blockCategoryVariants.push(_jsx(CollapseIt, { blockCategoryVariantsBlocks: blockCategoryVariantsBlocks, variantTitle: variantTitle }, panelId));
            });
            blockCategoryPanes.push(_jsxs(Tab.Pane, { eventKey: eventKey, children: [_jsx("div", { className: "title", children: _jsx("p", { children: categoryName }) }), _jsx("div", { className: "block-elements", children: _jsx(CustomScrollbar, { className: "scrollbar-ui-template-block-category", children: blockCategoryVariants }) })] }, eventKey));
        }
    });
    return (_jsxs(Tab.Container, { id: "toolbar-blocks-content", defaultActiveKey: firstElement, children: [_jsxs("div", { className: "template-block-category-inner", style: { height: '100%', display: 'flex', flexDirection: 'column' }, children: [_jsx(Nav, { variant: "pills", className: "nav-template-block-categories flex-row justify-content-start mb-2 px-2 pt-2 border-bottom", children: blockCategory }), _jsx("div", { className: "flex-grow-1", style: { overflow: 'hidden' }, children: _jsx(Tab.Content, { style: { height: '100%' }, children: blockCategoryPanes }) })] }), deviceType === 'desktop' && (_jsx(Tooltip, { id: "top", place: "top" }))] }));
};
const mapStateToProps = (state) => {
    return {
        ccToolbar: state.layout.ccToolbar,
        appIntl: state.intl,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setVariables: (data) => {
            dispatch(setVariables(data));
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(legacyInjectIntl(TemplateBlockCategoryFTs)));
